const EMPTY_ARRAY = [];

export const selectExternalCrmMilestones = ({ milestoneDefinitions }) =>
  milestoneDefinitions?.externalCrmMilestones || EMPTY_ARRAY;
